import { useState } from 'react'

import {
  Box,
  Title,
  WizardStepRenderParams,
  useOnNext,
} from '@factorialco/deprecated-design-system'

import { EmployeeForSelectFragmentNoAccess } from 'modules/core/components/EntitySelectWrapper/Entities/Employees/types'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { EmployeeSelector } from 'modules/employees/components/EmployeeSelector'
import { ClassWizardData } from 'modules/trainings/components/Revamp/NewClassWizard/hooks/useNewClassWizardSteps'

export const EmployeeSelectorStep = ({
  data,
  onDataChanged,
}: WizardStepRenderParams<ClassWizardData>) => {
  const [selectedEmployees, setSelectedEmployees] = useState<EmployeeForSelectFragmentNoAccess[]>(
    []
  )

  useOnNext(() => {
    track(trackingEvents.training.trainingGroupCreationWizard.goToParticipantsNextStep)
  })
  return (
    <Box gap="s24">
      <Title
        variant="500"
        title={i18n.t(
          'trainings.trainings_revamp.training_class.class_wizard.participants_step.title'
        )}
        description={i18n.t(
          'trainings.trainings_revamp.training_class.class_wizard.participants_step.description'
        )}
      />

      <EmployeeSelector
        alwaysOpen
        onSelect={(employees) => {
          setSelectedEmployees(employees)
          onDataChanged({
            ...data,
            employeeIds: employees.map((employee) => employee.id),
          })
        }}
        multiple
        value={selectedEmployees}
        allowedGroups={['all', 'teams', 'managers', 'workplaces']}
      />
    </Box>
  )
}
